import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import Loader from '../../loader';
import { GetUserLogin } from '../../services';

import './Signin.css'; // Make sure this CSS file exists

export default class Signin extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            password: "",
            redirectToReferrer: false,
            isloaded: false
        };
    }

    handleChangeUser = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        this.setState({ isloaded: true });
        const { email, password } = this.state;
        const user = await GetUserLogin.getUserLogin({ email, password });

        if (user) {
            GetUserLogin.authenticate(user, () => {
                this.setState({ redirectToReferrer: true, isloaded: false });
                window.location.reload();
            });
        } else {
            this.setState({ isloaded: false });
            NotificationManager.error("Please! Check Username & Password", "Input Field");
        }
    };

    render() {
        const { redirectToReferrer, isloaded } = this.state;

        if (redirectToReferrer || localStorage.getItem('token')) {
            return <Redirect to="/admin" />;
        }

        return (
            <div className="login-wrapper fade-in">
                <div className="login-card-container slide-up">
                    <div className="branding-section">
                        <img src="/images/JC-logo.png" alt="Embroidery Logo" className="brand-logo zoom-in" />
                        <h2 className="brand-name">JC Creations Admin</h2>
                        <p className="brand-desc">Manage your embroidered wonders seamlessly</p>
                    </div>
                    
                    <div className="form-section">
                        <form onSubmit={this.handleSubmit} className="login-form">
                            {isloaded && <Loader />}

                            <h3>Admin Login</h3>
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={this.state.email}
                                onChange={this.handleChangeUser}
                                required
                            />
                            <input
                                type="password"
                                name="password"
                                placeholder="Password"
                                value={this.state.password}
                                onChange={this.handleChangeUser}
                                required
                            />
                            {/* <div className="checkbox-container">
                                <input type="checkbox" id="remember" />
                                <label htmlFor="remember">Remember me</label>
                            </div> */}
                            <button type="submit" className="login-btn">Login</button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/auth/login/index.js